var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"properties"},[_c('property',{attrs:{"name":'סוג מנוי',"value":'פעיל'}}),_vm._v(" "),_c('property',{attrs:{"name":'תאריך חיוב הבא',"value":'מנוי ללא חיוב'}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }